var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeriesmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e0e2e2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20a8 8 0 01-5.57-2.26l8.48-2.83 2.83-8.48A8 8 0 0112 20zm-1.33-9.33l2.66 2.66-4 1.33zM4 12a8 8 0 0113.57-5.74L9.09 9.09l-2.83 8.48A8 8 0 014 12zm8-10a10 10 0 1010 10A10 10 0 0012 2z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeriesmin);
export default __webpack_public_path__ + "static/media/series.min.49667d681c2591b189041a240e8bd357.svg";
export { ForwardRef as ReactComponent };